var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Drawer',_vm._b({staticClass:"qv-drawer",on:{"close":_vm.onClose}},'Drawer',_vm.drawerProps,false),[_c('QuickView',_vm._b({},'QuickView',Object.assign({}, _vm.quickViewProps, {loading: _vm.loading, contentData: _vm.contentData, exposurData: _vm.exposurData, title: _vm.title}),false),[(
				_vm.quickViewProps &&
				_vm.quickViewProps.quickViewType === _vm.quickViewWindowType.Exposure &&
				_vm.quickViewProps.isExposureSlotAdded
			)?_c('template',{slot:"exposureEdit"},[_vm._t("exposureEdit")],2):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }